<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :top="top"
    :before-close="dialogBeforeClose"
    :close-on-click-modal="canClickClose"
  >
    <div class="dialog-content-wrapper">
      <div>
        <slot></slot>
      </div>
      <div class="footer">
        <el-button
          class="submit-btn"
          size="small"
          v-if="isShowCancel"
          @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button
          class="submit-btn"
          size="small"
          type="primary"
          :loading="confirmLoading"
          @click="submit"
        >{{ successBtn }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>


<script>
  export default {
    props: {
      title: {
        required: false,
        default: "",
      },
      showFlag: {
        required: true,
        type: Boolean,
      },
      isShowCancel: {
        required: false,
        type: Boolean,
        default: true,
      },
      width: {
        required: false,
        default: "550px",
      },
      successBtn: {
        required: false,
        default: "确定",
      },
      canClickClose: {
        required: false,
        default: true,
      },
      top: {
        required: false,
        default: "15vh",
      },
      confirmLoading: {
        required: false,
        default: false,
      },
    },

    computed: {
      dialogVisible: {
        get() {
          return this.showFlag;
        },
        set(val) {
          this.$emit("hideDialog", val, false);
        },
      },
    },

    methods: {
      /* 关闭前方法 */
      dialogBeforeClose() {
        this.dialogVisible = false;
        this.$emit('handleCloseBefor')
      },
      /* 提交方法 */
      submit() {
        this.$emit("hideDialog", false, true);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .footer {
    width: 100%;
    display: flex;
    justify-content: center;

    .submit-btn {
      padding: 9px 35px;
    }
  }
</style>
